// extracted by mini-css-extract-plugin
module.exports = {"root":"ModalUpdate_root__3YbUD","footer":"ModalUpdate_footer__c50zp"};